import gql from 'graphql-tag';

// `reconciled` and `claimed` arrive as JSON strings, exactly as the tick's own
// operator log line prints them. The screen parses them for display; keeping
// them opaque here means a new tally key needs no schema change on either side.
export const GET_VDO_MIGRATION_DASHBOARD = gql`
  query vdoMigrationDashboard($tickLimit: Int) {
    vdoMigrationDashboard(tickLimit: $tickLimit) {
      config { id enabled inflightCap updatedBy updatedAt }
      byStatus { status count }
      byReason { status reason count }
      inflight { id vdoSetTopicId bunnyVideoGuid submittedAt attempts }
      recentFailures { vdoSetTopicId reason lastError attempts }
      tickLogAvailable
      ticks {
        id startedAt durationMs outcome dryRun pid inflightCap
        reconciled claimed pending
        lockRenewals lockLost reconcileStoppedBy scanStoppedBy
      }
      auditLogAvailable
      audits { id at actor source action params ok result error }
    }
  }
`;

const CONFIG_FIELDS = `
  id enabled inflightCap updatedBy updatedAt
`;

export const ENABLE_VDO_MIGRATION = gql`
  mutation enableVdoMigration {
    enableVdoMigration { ${CONFIG_FIELDS} }
  }
`;

export const DISABLE_VDO_MIGRATION = gql`
  mutation disableVdoMigration {
    disableVdoMigration { ${CONFIG_FIELDS} }
  }
`;

export const SET_VDO_MIGRATION_CAP = gql`
  mutation setVdoMigrationCap($cap: Int!) {
    setVdoMigrationCap(cap: $cap) { ${CONFIG_FIELDS} }
  }
`;

// `orphaned` comes back on both paths: before the change it is what would be
// orphaned, after it what was. These Bunny videos are never deleted by this
// call and must be removed from the library by hand.
//
// `elsewhere` only appears when a reason was given and it matched zero
// FAILED rows -- requeue only ever touches FAILED jobs. Absent/null is the
// ordinary case; an empty array means the reason has no jobs anywhere;
// a non-empty array means the reason exists, just not on FAILED, and the
// screen must say so rather than let "requeued: 0" read as "nothing to do".
export const REQUEUE_VDO_MIGRATION_JOBS = gql`
  mutation requeueVdoMigrationJobs($reason: String, $confirmed: Boolean) {
    requeueVdoMigrationJobs(reason: $reason, confirmed: $confirmed) {
      needsConfirmation
      requeued
      orphaned { jobId vdoSetTopicId bunnyVideoGuid }
      elsewhere { status count }
    }
  }
`;

// Returns null when the tenant has no such topic. That is a successful
// answer, not an error, and the screen renders it as its own state.
export const GET_VDO_MIGRATION_TOPIC = gql`
  query vdoMigrationTopic($vdoSetTopicId: ID!) {
    vdoMigrationTopic(vdoSetTopicId: $vdoSetTopicId) {
      topic {
        id no vdoLength fileSize vdoResolution
        videoProvider bunnyVideoGuid bunnyStatus bunnyStatusAt
        vdoStreamPath vdoSet
      }
      job {
        id status reason attempts sortOrder
        bunnyVideoGuid submittedAt finishedAt lastError
      }
      divergent
    }
  }
`;
